import React, { useState } from "react";
import {
    Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import InputLabel from "@mui/material/InputLabel";


import MenuIcon from "@material-ui/icons/Menu";

const useStyles = makeStyles((theme)=>({
    link:{
        textDecoration:"none",
        color: "#000",
        fontSize: "20px",
    },
    icon:{
        color: "#000",
        width:'10px'
    },profileImg: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      objectFit: "cover",
      // marginLeft: theme.spacing(2),
      margin:'auto',
     
    },
}));

function DrawerComponent() {
    const classes = useStyles();
  const [openDrawer, setOpenDrawer] = useState(false);

  // Replace with your actual profile image URL
  const profileImgUrl = "/images/homepg-22.jpg";


  return (
    <>
      <Drawer
        open={openDrawer}
        onClose={() => setOpenDrawer(false)} className="navbar"
      >
        <List>
        <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <Link to="/" className={classes.link}>HOME</Link>
            </ListItemText>
          </ListItem>
          <Divider/>
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <Link to="/about" className={classes.link}>ABOUT US</Link>
            </ListItemText>
          </ListItem>
          
          <Divider/>
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <Link to="/contact" className={classes.link}>CONTACT US</Link>
            </ListItemText>
          </ListItem>
          <Divider/>
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <Link to="/more" className={classes.link}>MORE</Link>
            </ListItemText>
          </ListItem>
          {/* <Divider/> */}
          
          
        </List>

        {/* Profile Image */}
        <Link to="/login" className={classes.link}><div style={{ display: "flex", justifyContent: "flex-end" }}>
          <img src={profileImgUrl} alt="Profile" className={classes.profileImg} />
        </div><p style={{margin:'auto',textAlign:'center'}}>Login / Register</p></Link>


      </Drawer>
      <IconButton onClick={() => setOpenDrawer(!openDrawer)}className={classes.icon}>
        <MenuIcon />
      </IconButton>
    </>
  );
}
export default DrawerComponent;
